/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Validation_Terms_RequiredInputs */



/**
* | output |
* | --- |
* | "You must accept the terms and conditions" |
*
* @param {Form_Validation_Terms_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_validation_terms_required = /** @type {((inputs?: Form_Validation_Terms_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Validation_Terms_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Du musst den Nutzungsbedingungen zustimmen")
	return /** @type {LocalizedString} */ ("You must accept the terms and conditions")
});